module.exports = __webpack_public_path__ + "img/26-dodge-hornet.5fbf1cd6.jpg";